module.exports = __webpack_public_path__ + "static/img/8-EN.a58b5c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/8-EN.png
// module id = Fgjx
// module chunks = 1